import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {
  @Output() appClickOutside = new EventEmitter<Event>();
  constructor(private _elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    const clickedInside = this._elementRef.nativeElement.contains(target);

    if (!clickedInside) {
      this.appClickOutside.emit(event);
    }
  }

  @HostListener('document:touchstart', ['$event'])
  public onDocumentTouch(event: Event): void {
    const target = event.target as HTMLElement;
    const clickedInside = this._elementRef.nativeElement.contains(target);

    if (!clickedInside) {
      this.appClickOutside.emit(event);
    }
  }
}

//<div (appClickOutside)="close()" appClickOutside>

